import type { OcrContainer } from '../types';

interface ContainerTemplate {
  id: number;
  name: string;
}

/**
 * The OCR template a container will actually run with, in the same precedence
 * the backend's `resolveTemplatePool()` uses: the registration's candidate pool
 * first, then the form's configured template.
 *
 * Reading the form's template alone is wrong, because that relation is
 * `latestOfMany()` — on a form carrying several active templates it resolves to
 * the newest one, so a container whose template was chosen explicitly (the test
 * OCR dialog) displayed a template the operator never picked.
 *
 * `extra` counts the remaining pool candidates, so a multi-template pool can be
 * shown as "first (+N)" instead of silently hiding the rest.
 */
export function resolveContainerTemplate(container: OcrContainer): {
  template: ContainerTemplate | null;
  extra: number;
} {
  const pool = container.registration?.ocr_templates ?? [];

  if (pool.length > 0) {
    return { template: pool[0], extra: pool.length - 1 };
  }

  return {
    template: container.registration?.dynamic_form?.ocr_template ?? null,
    extra: 0
  };
}
